//import liraries
import React, { Component, useEffect, useState } from "react";
import { View, Text, ScrollView, FlatList } from "react-native";
import CHeader from "../../common/CHeader";
import MainContainer from "../../common/CWrapper";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import CText from "../../common/CText";
import { getTripTransactionList } from "../../api/tripInsurance";

// create a component
const TripTransactionHistory = (props) => {
  const headingData = [
    {
      id: 1,
      title: "Transaction Date",
      width: 145
    },
    {
      id: 2,
      title: "Transaction Time",
      width: 145
    },
    {
      id: 3,
      title: "Transaction No.",
      width: 145
    },
    {
      id: 4,
      title: "Transaction Details",
      width: 185
    },
    {
      id: 5,
      title: "Debit Amount",
      width: 145
    },
    {
      id: 6,
      title: "Credit Amount",
      width: 145
    },
    {
      id: 7,
      title: "Balance Amount",
      width: 145
    },
  ];

  const styles = useStyles();
  const [loading, setLoading] = useState(false)
  const [transactionData, setTransactionData] = useState([])

  const getTransactionList = () => {
    setLoading(true);
    getTripTransactionList().then(res => {
      setLoading(false);
      setTransactionData(res.data);
      console.log('getTransactionList:', res)
    }).catch((err) => {
      setLoading(false);
      console.log("Error:getTransactionList - ", err);
    });
  }

  useEffect(() => {
    getTransactionList()
  }, [])

  return (
    <MainContainer>
      <View style={styles.contentWrapper}>
        <CHeader
          showBack
          disputeHeader
          title="Insurance Transactions"
          onPress={() => props.setScreen(props.info.backNavigation)}
          showDesc={true}
        />
        <ScrollView horizontal={true}>
          <View style={{ width: "100%", borderRadius: 20 }}>
            <View style={styles.headerViewStyle}>
              {headingData.map((item) => {
                return (
                  <View style={styles.headerViewStyle}>
                    <CText.tiTransactionText style={{ width: item.width, minWidth: item.width }}>
                      {item.title}
                    </CText.tiTransactionText>
                    <View style={styles.verticalLineStyle} />
                  </View>
                );
              })}
            </View>
            <FlatList
              style={{}}
              showsVerticalScrollIndicator
              data={transactionData}
              showsHorizontalScrollIndicator
              keyExtractor = {(item, index) => index+"_"+item?.id?.toString() }
              renderItem={({ item, index }) => {
                console.log(item, "transactionData")
                return (
                  <View
                    style={[
                      styles.dataViewStyle,
                      {
                        backgroundColor:
                          index % 2 !== 0 ? "#ffffff" : "#E5E5E5",
                        borderBottomRightRadius: index == transactionData.length - 1 ? 15 : null,
                        borderBottomLeftRadius: index == transactionData.length - 1 ? 15 : null
                      },
                    ]}
                  >
                    <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                      {item.dateTime}
                    </CText.tiTransactionText>
                    <View style={styles.verticalLineStyle} />
                    <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                      {item.dateTime}
                    </CText.tiTransactionText>
                    <View style={styles.verticalLineStyle} />
                    <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                      {item.transId}
                    </CText.tiTransactionText>
                    <View style={styles.verticalLineStyle} />
                    <CText.tiTransactionText style={{ width: 185, minWidth: 185 }}>
                      {item.tollPlaza}
                    </CText.tiTransactionText>
                    <View style={styles.verticalLineStyle} />
                    <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                      {item.statementType == "D" ? item.price : "-"}
                    </CText.tiTransactionText>
                    <View style={styles.verticalLineStyle} />
                    <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                      {item.statementType == "C" ? item.price : "-"}
                    </CText.tiTransactionText>
                    <View style={styles.verticalLineStyle} />
                    <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                      {item.amountBalance}
                    </CText.tiTransactionText>
                  </View>
                );
              }}
            />
          </View>
        </ScrollView>
      </View>
    </MainContainer>
  );
};

// define your styles
const useStyles = CreateResponsiveStyle({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#2c3e50",
  },
  contentWrapper: {
    width: "100%",
    height: "100%",
  },
  headerViewStyle: {
    flexDirection: "row",
    backgroundColor: "#ffffff",
  },
  verticalLineStyle: {
    width: 0.5,
    height: "100%",
    backgroundColor: "#a0a0a0",
  },
  dataViewStyle: {
    flexDirection: "row",
  },
});

//make this component available to the app
export default TripTransactionHistory;
